import React, { useRef, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import RightSidetext from "./rightsideTextDrawer";
import { SocketIOProvider, useSocket } from "use-socketio";
import GlobalApi from "../../Global";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import FormControl from "@material-ui/core/FormControl";
import refresh_token from "../../Global/refresh_token";
import Grid from "@material-ui/core/Grid";
import AccountCircle from "@material-ui/icons/AccountCircle";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import "./action.css";
import { TextField, Button, Typography } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import SendIcon from "@material-ui/icons/Send";
import attachmentIcon from "../../Assets/attachment.png";
import send from "../../Assets/send.png";
import sendG from "../../Assets/sendG.png";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import { useHistory } from "react-router-dom";
import ModalImage from "react-modal-image";
import Compressor from "compressorjs";
import swal from "@sweetalert/with-react";
import DarkButton from "../../Global/DarkButton";
import Colors from "../../Global/colors";
import Spinner from "../../Global/Spinner";
import clientSocket from 'socket.io-client';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation, UseTranslationOptions } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: "none",
  },
}));
const status = ["To Do", "In Progress", "Complete", "Can't Do"];

const priority = ["High Priority", "Medium Priority", "Low Priority"];

function Main(props) {
const {t} = useTranslation();
  console.log("props",props.id)
  let currentCompany = useSelector((state) => state.companyReducer.company);
  const classes = useStyles();
  const history = useHistory();
  const id = props.id;

  //const { socket } = useSocket();
  const socket = props.socket

  const [currentUser] = React.useState(
    JSON.parse(localStorage.getItem("UserData"))
  );

  const [actionChat, setActionChat] = React.useState([]);

  const [actionData, setActionData] = React.useState({});
  const [users, setUsers] = React.useState([]);
  const [groups, setGroups] = React.useState([]);
  const [text, setText] = React.useState("");
  // const [singleFile, setSingleFile] = React.useState("");

  const [userList, setUserList] = React.useState([]);
  const [site, setSites] = React.useState([]);

  let [packageDetails, setPackageDetails] = React.useState({});
  let [currentFileSize, setCurrentFileSize] = React.useState(0);
  const dispatch = useDispatch();
  useEffect(() => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    // props.func();
    fetchActionData();
    fetchUsers();
    socket.emit("join", { room: id, name: data.user_id }, (error) => {
      if (error) {
        alert(error);
      }
    });
    getSites();
    getPackage();
    getFileSize();
    getGroups();
    return () => {
      //socket.emit("disconnect");
      socket.off();
    };
  }, [currentCompany]);

  const getGroups = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: currentCompany.id,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

      fetch(GlobalApi + "/companygroups/get_all_company_groups?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          console.log("response of group",response);
          if (response.msg === "success") {
         setGroups(response.groups);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();

          if (status) {
            // console.log("opopopop");
            getGroups();
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };

  
  
  function getPackage() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      organization_id: data.organization_id,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Package/get_package_history?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          console.log(response.data);

          setPackageDetails(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            getPackage();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  function getFileSize() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      user_id: data.user_id,
      organization_id:data?.organization_id
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/ConfigFileSize/get_all_file_sizes_user?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          console.log(response.data);
          dispatch({ type: "SET_FILE_SIZE", payload: response.data });
          setCurrentFileSize(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            getPackage();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  function getSites() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let organization_id = data.organization_id;
    let params = {
      company_id: currentCompany.id,
    };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Region/get_all_regions?" + query, {
      method: "get",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    })
      .then((response) => response.json())
      .then(async (data) => {
        let arr = [];
        await data.data.map(async (value, index) => {
          //console.log(value.title);
          await value.Areas.map(async (area, i) => {
            await area.Sites.map((sites, j) => {
              // console.log(value.title, area.title, sites.title);
              let obj = {
                title: sites.title,
                id: sites.id,
              };
              if (sites.status !== "deactivated") {
                arr.push(obj);
              }
              //console.log(obj);
            });
            //console.log(this.state.row);
            //console.log(result.title,value.title);
          });
        });
        setSites(arr);
      });
  }

  const fetchActionData = () => {
    
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      action_id: id,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Action/get_action?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("response from fetch Action Data>>>>>>>>", response);
        if (response.status == "Success") {
          setActionData(response.data);
          //alert(JSON.stringify( response.data))
          
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchActionData();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  const fetchUsers = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: currentCompany.id,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/User/get_entity?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("Response from Get Users_______________________________________________________________________________________________________________________", response);
        if (response.status == "Success") {
          setUsers(response.data);
         
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchUsers();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  function handleChange(e) {
    setText(e.target.value);
  }

  function handleActionData(e, n) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    console.log(actionData.inspection_id, "action.inspection_id")
    if (n === "user_id") {
     
      
      setActionData({
        ...actionData,
        ["Users"]: e,
        [n]:null
      });
      let updatedUsers=[]
      let userList=""
      e.map(item=>{
        updatedUsers.push(item.id)
        userList=userList + item.first_name + " "+item.last_name+ ","
      })
      userList = userList.substring(0,userList.length-1)
      //alert(JSON.stringify(updatedUsers))
      //return
      //onSend(e.first_name + " " + e.last_name + " as assignee", "", "event");
      onSend("Action assignee(s) has been updated " + userList)
      
      fetch(GlobalApi + "/Action/edit_action", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          company_id:currentCompany.id,
          action_id: id,
          inspection_id: actionData.inspection_id,
          multiple_users:true,
          //[n]: e.id,
          multiple_users_arr:updatedUsers
        }),
      })
        .then((response) => response.json())
        .then(async (res) => {
          if (res.status === "Success") {
            console.log("ipdated");
          }
        });
      return;
    }

    if (e.target && e.target.name === "status") {
      const { value, name } = e.target;
      // setActionData({
      //   ...actionData,
      //   [name]: value,
      // });
      setActionData({
        ...actionData,
        [name]: value,
      });
      onSend(name + " to " + value, "", "event");
      fetch(GlobalApi + "/Action/edit_action", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          company_id:currentCompany.id,
          action_id: id,
          inspection_id: actionData.inspection_id,
          [name]: value,
          status_updated: new Date(),
        }),
      })
        .then((response) => response.json())
        .then(async (res) => {
          if (res.status === "Success") {
            console.log("ipdated");
          }
        });
      return;
    }

    if (
      e.target &&
      (e.target.name === "title" || e.target.name === "description")
    ) {
      const { value, name } = e.target;

      setActionData({
        ...actionData,
        [name]: value,
      });
      // fetch(GlobalApi + "/Action/edit_action", {
      //   method: "post",
      //   headers: new Headers({
      //     Authorization: "Bearer " + token,
      //     "Content-Type": "application/json",
      //   }),
      //   body: JSON.stringify({
      //     action_id: id,
      //     [name]: value,
      //   }),
      // })
      //   .then((response) => response.json())
      //   .then(async (res) => {
      //     if (res.status === "Success") {
      //       console.log("ipdated");
      //     }
      //   });
      return;
    }

    if (n === "site") {
      console.log("SITE");
      // setActionData({
      //   ...actionData,
      //   [name]: value,
      // });
      setActionData({
        ...actionData,
        [n]: e,
      });
      onSend(n + " to " + e.title, "", "event");
      fetch(GlobalApi + "/Action/edit_action", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          company_id:currentCompany.id,
          action_id: id,
          ["site"]: e.id,
          inspection_id: actionData.inspection_id,
        }),
      })
        .then((response) => response.json())
        .then(async (res) => {
          if (res.status === "Success") {
            console.log("ipdated");
          }
        });
      return;
    }

    if (n && n !== "user_id" && n !== "site") {
      console.log(n, e);
      setActionData({
        ...actionData,
        [n]: e,
      });
      onSend(n + " to " + e, "", "event");
      fetch(GlobalApi + "/Action/edit_action", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          company_id:currentCompany.id,
          action_id: id,
          inspection_id: actionData.inspection_id,
          [n]: e,
        }),
      })
        .then((response) => response.json())
        .then(async (res) => {
          if (res.status === "Success") {
            console.log("ipdated");
          }
        });
      return;
    } else {
      const { value, name } = e.target;
      setActionData({
        ...actionData,
        [name]: value,
      });
      onSend(
        name + " to " + moment(new Date(value)).format("DD MM yyyy"),
        "",
        "event"
      );
      fetch(GlobalApi + "/Action/edit_action", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          company_id:currentCompany.id,
          action_id: id,
          inspection_id: actionData.inspection_id,
          [name]: value,
        }),
      })
        .then((response) => response.json())
        .then(async (res) => {
          if (res.status === "Success") {
            console.log("ipdated");
          }
        });
    }
  }

  

  async function handleDelete() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;

    swal({
      title: t("Are you sure?"),
      text: t("All Data Including Media will be permenantly Deleted!"),
      icon: "warning",
      buttons: [<>{t("No, cancel it!")}</>, <>{t("Yes, I am sure!")}</>],
      dangerMode: true,
    }).then(async function(isConfirm) {
      if (isConfirm) {
        try {
          let res = await fetch(GlobalApi + "/Action/edit_action", {
            method: "post",
            headers: new Headers({
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              company_id:currentCompany.id,
              action_id: id,
              ["isDeleted"]: true,
            }),
          });
      
          let resJson = await res.json();
          console.log(resJson.data);
          history.goBack();
          getFileSize();

        } catch (err) {
          console.log(err);
        }
      } else {
        console.log("Canceled");
      }
    });

    
    
  }

  function onSend(text, image, status = "") {
    
    socket.emit("sendMessage", {
      text: text,
      user_id: currentUser.user_id,
      image: image,
      status: status,
      action_id: actionData.id,
    });

    setText("");
  }

  let uploadImage = async (singleFile = null) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let user_id = data.user_id;
    let organization_id = data.organization_id;
    console.log(data);
    //Check if any file is selected or not
    if (singleFile != null) {
      //If file selected then create FormData
      await new Compressor(singleFile, {
        quality: 0.6,
        convertSize: 0,
        async success(result) {
          if (result.size / 1024 / 1024 <= 10) {
            let fileSize = result.size / 1024 / 1024 + currentFileSize;
            if (fileSize < parseInt(packageDetails.file_size_per_user)) {
              const fileToUpload = singleFile;
              const data = new FormData();
              data.append("name", "Image Upload");
              data.append("images", fileToUpload);
              data.append("company_id", currentCompany.id);
              data.append("user_id", user_id);
              let res = await fetch(GlobalApi + "/Action/image_upload", {
                method: "post",
                body: data,
                headers: new Headers({
                  Authorization: "Bearer " + token,
                  // "Content-Type": "multipart/form-data; ",
                }),
              });
              let responseJson = await res.json();

              if (responseJson.status == "Success") {
                onSend("", responseJson.data);
                fetch(GlobalApi + "/ConfigFileSize/create_file_size", {
                  method: "Post",
                  headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                  }),
                  body: JSON.stringify({
                    action_id: actionData.id,
                    file_size: result.size,
                    file_type: "image",
                    file_url: responseJson.data,
                    organization_id: organization_id,
                    user_id: user_id,
                    identifier: "action",
                  }),
                })
                  .then((data) => data.json())
                  .then((data) => {
                    console.log(data);
                    getFileSize();
                  });
              }
            } else {
              swal(
                <>{t("Storage Limit Exceeded")}</>,
                <>{t("Upload a small file or update your package")}</>,
                "warning"
              );
            }
          } else {
            swal(
              <>{t("File Size Exceeded")}</>,
              <>{t("File size should be 10 MB or less")}</>,
              "warning"
            );
          }
        },
        error(err) {
          console.log(err.message);
        },
      });
    } else {
      //if no file selected the show alert
      alert("Please Select File first");
    }
  };

  // function handleImage(event) {

  // }
  console.log(id, "I_________________ID_________________I");

  function handleEditDes() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let user_id = data.user_id;
    let organization_id = data.organization_id;
    fetch(GlobalApi + "/Action/edit_action", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        company_id:currentCompany.id,
        action_id: id,
        title: actionData.title,
        description: actionData.description,
      }),
    })
      .then((response) => response.json())
      .then(async (res) => {
        if (res.status === "Success") {
          console.log("ipdated");
          swal(<>{t("Success")}</>, <>{t("Title and Description Saved Successfully")}</>, "success")
        }
      });
  }


  // if (actionData === null || users.length == 0) {
  //   return <Spinner />;
  // } else {
    return <div  style={{ padding: "0px", overflow: "auto"}}>
    
        <Grid container  style={{boxShadow:' 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)',overflow:'auto', borderRadius:'5px'}}>
        <Grid item xs={12} style={{ padding: "20px", backgroundColor: "white" }}>
            <div style={{ // minHeight: "80vh",
                border: "1px solid #e0e0e0", maxHeight: "77vh", overflowY: "auto", padding: 10 }}>
              {/* <RightSidetext
                  actionData={actionData}
                  userList={userList}
                  status={status}
                  site={site}
                  priority={priority}
                  users={users}
                  handleActionData={handleActionData}
                  currentUser={currentUser}
                  handleEditDes={handleEditDes}
                /> */}

              {(actionData.id == undefined || users.length == 0) && <Spinner />}

              {actionData.id !== undefined && users.length !== 0 && <RightSidetext actionData={actionData} userList={userList} status={status} site={site} priority={priority} users={users} groups={groups} handleActionData={handleActionData} handleDelete={handleDelete} currentUser={currentUser} handleEditDes={handleEditDes} />}
            </div>
          </Grid>
          <Grid item xs={12}  style={{ padding: "20px", backgroundColor: "white",  }}>
              {/* <Typography variant="h6">
                Data Storage Limit: {currentFileSize !== 0 ? currentFileSize?.toFixed(2) : 0} / {packageDetails?.file_size_per_user} MB
              </Typography> */}
            <div>
              <ChatComponent actionChat={actionChat} currentUser={currentUser} actionData={actionData} socket={socket} id={id} handleDelete={handleDelete} otherUser={users.filter(
                    (v) =>
                      actionData.created_by === currentUser.user_id
                        ? v.id === actionData.user_id
                        : v.id === actionData.created_by
                  )[0]} />
              <Grid container>
                <Grid item xs={12} style={{ padding: 0, margin: 0 }}>
                  <div style={{ width: "100%" }}>
                    {/* <div className="col ">
                     
                    </div> */}

                    <Grid container // spacing={1}
                      alignItems="center" justify="center" style={{ background: "#f5f5f5", padding: "20px",border: "1px solid #e0e0e0" }
                        // marginRight: 20,
                      }>
                      <Grid item xs={2} align="center">
                        <input accept="image/*" className={classes.input} id="icon-button-file" type="file" onChange={(e) => uploadImage(e.target.files[0])} />
                        <label htmlFor="icon-button-file">
                          <IconButton color="primary" aria-label="upload picture" component="span">
                          <img src={attachmentIcon} width={25} />
                          </IconButton>
                        </label>
                      </Grid>
                      <Grid item xs={8} style={{ backgroundColor: "pink" }}>
                        <FormControl fullWidth>
                          <TextField id="outlined-basic" value={text} autoComplete="off" name="text" onChange={handleChange} style={{ backgroundColor: "white", borderRadius: 5, width: "100%" }} onKeyPress={(e) => {
                              console.log(e);
                              if (e.key === "Enter") {
                                onSend(text);
                              }
                            }} fullWidth variant="outlined" />
                        </FormControl>
                      </Grid>
                      <Grid item xs={2} align="center">
                        <IconButton color="primary" aria-label="upload picture" component="span" disabled={text === ""} // style={{ marginTop: "18px", color: "white" }}
                          onClick={() => onSend(text)}>
                          <img src={text === "" ? sendG : send} width={20} />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
         
        </Grid>
      </div>;

}

export default function CreateAction(props) {
  const [currentUser] = React.useState(
    JSON.parse(localStorage.getItem("UserData"))
  );
  let localstorage2 = localStorage.getItem("UserData");
  let currentCompany = useSelector((state) => state.companyReducer.company);
  var data2 = JSON.parse(localstorage2);
  const socket =  clientSocket(`${GlobalApi.replace("/api", "")+"?userId="+data2.user_id}`
  ,{transports:["websocket"]}
  );

  
  return (
    // <SocketIOProvider
    //   url={GlobalApi.replace("/api", "")}
    //   opts={{
    //     query: {
    //       userId: currentUser.user_id,
    //     },
    //     //withCredentials:false
    //     //transports: ["websocket"]
    //   }}
    // >
      <Main {...props} socket={socket}/>
    // </SocketIOProvider>
  );
}

class ChatComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chatData: [],
    };
  }

  componentDidMount() {
    this.fetchChat();

    this.props.socket.on("message", (message) => {
      console.log(message);

      let chat = this.state.chatData;
      chat.push(message);

      this.setState({ chatData: chat });
      this.scrollToBottom();
      // if(chatRef.length === actionChat.length) {
      // chatRef = [...actionChat, message];
      // // } else {
      // setActionChat([...actionChat, message]);
      // }
    });
  }

  scrollToBottom = () => {
    const scrollHeight = this.messagesEnd.scrollHeight;
    const height = this.messagesEnd.clientHeight;
    const maxScrollTop = scrollHeight - height;
    this.messagesEnd.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
  };

  fetchChat = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      action_id: this.props.id,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Action/get_action_chat?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response);
        if (response.status == "Success") {
          this.setState({
            chatData: response.data.sort(
              (a, b) =>
                new Date(a.createdAt).getTime() -
                new Date(b.createdAt).getTime()
            ),
          });
          this.scrollToBottom();
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            this.fetchChat();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };
  // shouldComponentUpdate(nextProps, nextState) {
  //   console.log(this.state.chatData.length !== nextState.chatData.length);
  //   return this.state.chatData.length !== nextState.chatData.length;
  // }
  render() {
    const { actionChat, currentUser, actionData, otherUser } = this.props;
    console.log("_________LOOOP CHECK", actionData);
    return (
      <div style={{padding:'10px', background: "#f5f5f5",border: "1px solid #e0e0e0",}}>
      <div
      className="scrollbarShow2"
        ref={(el) => {
          this.messagesEnd = el;
        }}
        style={{
          background: "#f5f5f5",
          minHeight: "56vh",
          maxHeight: "56vh",
          overflowY: "scroll",
          
          // padding: 10,
        }}
      >
        <ul>
          {this.state.chatData.map((v) => {
            return (
              <Bubble
                v={v}
                currentUser={currentUser}
                actionData={actionData}
                otherUser={otherUser}
              />
            );
          })}
        </ul>
      </div>
      </div>
    );
  }
}

class Bubble extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.v.title !== nextProps.v.title ||
      this.props.otherUser !== nextProps.otherUser
    );
  }
  render() {
    const { v, currentUser, actionData, otherUser } = this.props;
    console.log(otherUser);
    return (
      <div
        key={v.id}
        style={{
          textAlign: v.user_id === currentUser.user_id ? "right" : "left",
          margin: 15,
        }}
      >
        {v.status === "event" && v.text !== "" ? (
          <span className="eventBubble">
            {v.user_id === currentUser.user_id
              ? "You changed "
              : `${otherUser ? otherUser.first_name : ""} ${
                  otherUser ? otherUser.last_name : ""
                } changed`}{" "}
            {v.text}
          </span>
        ) : v.text === "" ? (
          <Grid
            container
            justify={
              v.user_id !== currentUser.user_id ? "flex-start" : "flex-end"
            }
          >
            <Grid item xs={6}>
              <div>
                <ModalImage
                  small={Colors.fileUrl + v.image}
                  large={Colors.fileUrl + v.image}
                  alt=""
                  style={{ width: "200px" }}
                  // width="200px"
                  // height="200px"
                />
              </div>
            </Grid>
          </Grid>
        ) : (
          <span
            className={
              v.text === ""
                ? ""
                : v.user_id === currentUser.user_id
                ? "chatBubble"
                : "chatBubble-right"
            }
          >
            {v.text}
          </span>
        )}

        <p
          style={{
            margin: 5,
            padding: 0,
            fontSize: 12,
            fontWeight: "bold",
            color: "gray",
          }}
        >
          {new Date(v.createdAt).getDate()}{" "}
          {getMonth(new Date(v.createdAt).getMonth())},{" "}
          {new Date(v.createdAt).getHours().toString().length == 1
            ? "0" + new Date(v.createdAt).getHours()
            : new Date(v.createdAt).getHours()}
          :
          {new Date(v.createdAt).getMinutes().toString().length == 1
            ? "0" + new Date(v.createdAt).getMinutes()
            : new Date(v.createdAt).getMinutes()}
        </p>
      </div>
    );
  }
}

function getMonth(e) {
  switch (e) {
    case 0:
      return "Jan";
    case 1:
      return "Feb";
    case 2:
      return "Mar";
    case 3:
      return "Apr";
    case 4:
      return "May";
    case 5:
      return "Jun";
    case 6:
      return "Jul";
    case 7:
      return "Aug";
    case 8:
      return "Sep";

    case 9:
      return "Oct";
    case 10:
      return "Nov";
    case 11:
      return "Dec";
    default:
      return "";
  }
}
